export { WorkspaceView } from './assets';
